module.exports = __webpack_public_path__ + "img/aerostato_transparent.8cd7dde7.png";